<template>
  <CustomModal position="absolute" @close="$emit('close')">
    <template #body>
      <CreateTransaction class="transaction-form -m-8 lg:-m-12 md:mr-0 lg:mr-0"
                         :default-form-is-closed="false"
                         :sync-banks-available="false"
                         :transaction-type="transactionType"
                         :transaction-options-list="transactionOptions"
                         :initial-date="transactionDate"
                         @changeType="transactionType = $event"
                         @toggleOption="changeTransactionOption($event)"
                         @success="$emit('success')"/>
    </template>
  </CustomModal>
</template>

<script>
import CustomModal from "@/components/UI/modals/CustomModal";
import CreateTransaction from "@/components/common/CreateTransaction/CreateTransaction";

export default {
  name: "CreateTransactionModal",
  components: {CreateTransaction, CustomModal},
  props: {
    transactionDate: {
      type: String
    }
  },
  data() {
    return {
      initialDate: null,
      transactionType: 2,
      transactionOptions: {
        agent: false,
        comment: false,
        tags: false,
        category: false,
        calendar: true,
      }
    }
  },
  methods: {
    changeTransactionOption(name) {
      this.transactionOptions[name] = !this.transactionOptions[name];
    }
  },
  mounted() {
    if (this.transactionDate) {
      this.initialDate = this.transactionDate;
    }
  }
}
</script>

<style lang="scss">
.transaction-form {
  width: 800px;
}
</style>